import { authAPI } from './apiService'
import { Obj, ObjValueDictionary, ObjValueNumber, ObjValueText } from './models'

export type GetObjsResponse = {
  objs: Obj[];
}

const URL = '/objs'

// Числовой диапазон приходит парой [min, max], где незаданная граница — null.
// В query такие фильтры уходят одним значением 'min,max'; пустая часть парсится
// бэкендом обратно в null. Словарные остаются массивом и разворачиваются axios
// в 'd:<id>=v1&d:<id>=v2'.
export type MapFilters = { [key: string]: number[] | (number | null)[] }

const toMapParams = (filters: MapFilters): { [key: string]: number[] | string } => {
  const params: { [key: string]: number[] | string } = {}
  Object.keys(filters).forEach(key => {
    const value = filters[key]
    if (!Array.isArray(value)) return
    if (key.indexOf('n:') === 0) {
      const [min, max] = value as (number | null)[]
      params[key] = `${min ?? ''},${max ?? ''}`
      return
    }
    params[key] = value as number[]
  })
  return params
}

const objsService = {

  get: (layerId: number, filters: { [key: string]: number[] }) => authAPI
    .get<GetObjsResponse>(URL, {
      params: {
        layerId,
        ...filters
      }
    })
    .then((response) => response.data),

  map: (layerId: number, filters: MapFilters) => authAPI
    .get<GetObjsResponse>(`${URL}/map`, {
      params: {
        layerId,
        ...toMapParams(filters)
      }
    })
    .then((response) => response.data),

  getById: (id: number) => authAPI
    .get<{ obj: Obj }>(`${URL}/${id}`)
    .then((response) => response.data),

  create: (
    name: string,
    layerId: number,
    long: number,
    lat: number,
    numbers: ObjValueNumber[],
    dictionaries: ObjValueDictionary[],
    src: string,
    description: string,
    texts: ObjValueText[]
  ) => authAPI
    .post(`${URL}/create`, { name, layerId, long, lat, numbers, dictionaries, src, description, texts })
    .then((response) => response.data),

  update: (
    id: number,
    name: string,
    layerId: number,
    long: number,
    lat: number,
    numbers: ObjValueNumber[],
    dictionaries: ObjValueDictionary[],
    src: string,
    description: string,
    texts: ObjValueText[]
  ) => authAPI
    .post(`${URL}/update`, { id, name, layerId, long, lat, numbers, dictionaries, src, description, texts })
    .then((response) => response.data)
}

export default objsService
